import classNames from 'classnames/bind';
import styles from './AcfAccordionItem.module.scss';
let cx = classNames.bind(styles);
import { AccordionDetails, AccordionHeading, AccordionItem, Heading, RichText, Card } from '@/components';

export default function AcfAccordionItem(props) {
	const { item, elem, isCard, accordionSettings, anchor } = props;

	function renderAccordionItem() {
		return (
			<AccordionItem accordionSettings={accordionSettings} anchor={anchor}>
				<AccordionHeading>
					<Heading level={elem} className={cx(['accordion-heading'])}>
						{item.header}
					</Heading>
				</AccordionHeading>
				<AccordionDetails>
					<RichText className={cx(['accordion-rich-text'])} html={item.body} />
				</AccordionDetails>
			</AccordionItem>
		);
	}
	return <>{!isCard ? renderAccordionItem() : <Card className={cx('accordion-card')}>{renderAccordionItem()}</Card>}</>;
}
